import React from 'react'
import { Grid, Box, Button} from '@mui/material';

import { TransactionsTable } from './TransactionsTable';
import { TransactionsForm } from './TransactionsForm';

export const ModalTransactions = ({ useFetchInit, dataModal }) => {

    const {
        //------------- Generales
        //------------- globalStates
        globalStates,
        //------------- Helpers
        // Helpers,
        //------------- Formularios
        // Forms,
        //------------- FetchData
        // FetchData,
        //------------- Actions
        Actions
    } = useFetchInit

    // ------------------------------------------------ Generales
    
    // ------------------------------------------------ globalStates
    const { showTransactionsForm } = globalStates
    
    // ------------------------------------------------ Helpers
    
    // ------------------------------------------------ Formularios
    
    // ------------------------------------------------ FetchData
    
    // ------------------------------------------------ Actions
    const {
        handleClickShowTransactionForm
    } = Actions

    const { dataRequest } = dataModal
    // console.log(dataModal)
    // console.log(dataRequest)

    return (
        <>
            <div className="border-bottom border-dark"></div>
            <div className="pt-1"></div>
            {(!showTransactionsForm) && (
                <>
                    <Box pt={4} pb={4}>
                        <Grid container spacing={2} justifyContent="flex-end">
                            <Grid item>
                                <Button
                                    style={{background: "#4b4b4c"}}
                                    variant="contained"
                                    type="submit"
                                    disabled={(parseFloat(dataRequest.total_saldo) === 0) ? true : false}
                                    onClick={()=>handleClickShowTransactionForm(true, 'EDITABLE')} 
                                >
                                    <i className="fa-solid fa-circle-plus"></i> &nbsp; AGREGAR
                                </Button>
                            </Grid>
                        </Grid>
                    </Box>

                    <TransactionsTable useFetchInit={useFetchInit} dataModal={dataModal} />
                </>
            )}

            {(showTransactionsForm) && (
                <>
                    <TransactionsForm useFetchInit={useFetchInit} dataModal={dataModal} />
                </>
            )}
        </>
    )
}
